import { Directive, Input } from '@angular/core';

@Directive()
export abstract class MetadataAreaAbstract {
  // Metadata can be edited or only viewed
  @Input() isEdit: boolean = false;    // Default: we can't edit data
}
